import script from "./FollowersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowersSection.vue?vue&type=script&setup=true&lang=js"

import "./FollowersSection.vue?vue&type=style&index=0&id=0222771c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0222771c"]])

export default __exports__